var v1="<ol class=\"breadcrumb\" ng-if=\"!vm.dataService.addNewMode\"> <li ng-repeat=\"path in vm.pathArray\"> <a ng-href=\"#/{{ path.url }}\"> {{ path.name }}</a> </li> </ol>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaBreadCrumb.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaBreadCrumb/lbaBreadCrumb.html
// module id = 259
// module chunks = 0